import {
	Legend,
	LegendContent,
	ValuesLegendItem,
} from '../../../../../atoms/Legend';
import PropTypes from 'prop-types';
import {GradientBarLegend, Triangle} from '../../../../../specific/Legends';

const renderWmsLegendContent = key => {
	switch (key) {
		case 'elevation':
			return (
				<div className="insar-MultipleLegendBars one-one-three">
					<div>
						<GradientBarLegend
							colors={['#0101FF', '#61b3ff', '#bcffee']}
							labels={['0 m', '1 m', '2 m']}
						/>
					</div>
					<div>
						<GradientBarLegend
							colors={['#bcffee', '#fdfdcf', '#fbfdcd']}
							labels={['2 m', '6 m', '10 m']}
						/>
					</div>
					<div>
						<GradientBarLegend
							colors={['#fbfdcd', '#56bc3a', '#bcb316', '#be7f26', '#b2472e']}
							labels={['10 m', '250 m', '500 m', '750 m', '1000 m']}
						/>
					</div>
				</div>
			);
		case 'height':
			return (
				<GradientBarLegend
					colors={['#08306B', '#529DCC', '#F7FBFF']}
					labels={['0 m', '5 m']}
				/>
			);
		case 'slope':
			return (
				<GradientBarLegend
					colors={['#FFFFFF', '#FEFF51', '#FD8C3B', '#FF0037']}
					labels={['0°', '60°']}
				/>
			);
		case 'refPoints':
			return (
				<LegendContent compact>
					<ValuesLegendItem
						name="Reference point"
						render={() => <Triangle size={12} color="#000000" />}
					/>
					<ValuesLegendItem
						name="GNSS Station SAMO (Apia)"
						render={() => <Triangle size={12} color="#FF00BB" />}
					/>
					<ValuesLegendItem
						name="GNSS Station FALE"
						render={() => <Triangle size={12} color="#B81BB8" />}
					/>
					<ValuesLegendItem
						name="Tide Gauge (Apia)"
						render={() => <Triangle size={12} color="#0101FF" rotate={180} />}
					/>
				</LegendContent>
			);
		case 'damSite':
			return (
				<ValuesLegendItem className="insar-DamSiteLegend" name="Dam site" />
			);
		default:
			return null;
	}
};

const WmsLayersLegend = ({active, layerKey}) => {
	return <Legend hidden={!active}>{renderWmsLegendContent(layerKey)}</Legend>;
};

WmsLayersLegend.propTypes = {
	active: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	layerKey: PropTypes.string,
};

export default WmsLayersLegend;
